import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Carousel } from "react-bootstrap";
import banner from "../../Assets/img/banner2.avif";
import { useNavigate } from "react-router-dom";
import PublicHeader from "../Header/PublicHeader";
import Footer from "../Footer";

function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

const TnCBuilding = importAll(require.context('../../Assets/img/ServicesGallery/Training & Capacity/', false, /\.(png|jpe?g|svg|JPG)$/));
const CnNEvents = importAll(require.context('../../Assets/img/ServicesGallery/Conference & Networking', false, /\.(png|jpe?g|svg|JPG)$/));
const Webinar = importAll(require.context('../../Assets/img/ServicesGallery/Webinars & Workshops', false, /\.(png|jpe?g|svg|JPG)$/));
const Reward = importAll(require.context('../../Assets/img/ServicesGallery/Rewards & Recognition', false, /\.(png|jpe?g|svg|jpg)$/));
const RnKDev = importAll(require.context('../../Assets/img/ServicesGallery/Research & Knoweledge', false, /\.(png|jpe?g|svg|JPG)$/));
const Public = importAll(require.context('../../Assets/img/ServicesGallery/Public Awareness', false, /\.(png|jpe?g|svg|JPG)$/));

const Empowers = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // ✅ Real-time viewport detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleContact = () => {
    navigate('/membership/plans');
  };

  const createCarouselItems = (images) => {
    return Object.values(images).map((img, index) => (
      <Carousel.Item key={index}>
        <div>
          <img
            className="d-block w-100"
            src={img}
            alt={`Slide ${index + 1}`}
            style={{ maxHeight: '500px', objectFit: 'cover' }}
          />
        </div>
      </Carousel.Item>
    ));
  };

  const sectionStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '50px 20px',
    gap: '30px',
    flexDirection: isMobile ? 'column' : 'row',
  };

  const contentStyle = {
    flex: '1',
    minWidth: '300px',
    maxWidth: '600px',
    textAlign: isMobile ? 'left' : 'left'
  };

  const carouselStyle = {
    flex: '1',
    minWidth: '300px',
    maxWidth: '600px'
  };

  return (
    <>
      <PublicHeader />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Banner Section */}

        <div
          className="section-header md:mt-[40px] mt-0"
        >
          <div className='header-content px-5'>
            <div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className='text-left'
            >
              <h1 className='display-4 fw-bold mb-2 text-white'>
                How APCCI Empower You
              </h1>
            </div>
          </div>
          <div className='overlay'></div>
        </div>
        <h3 className="text-4xl sm:text-3xl font-bold text-gray-800 mb-0 m-4 text-center">Why Join APCCI</h3>
        {/* Sections */}
        <div>
          {[
            {
              title: "Training & Capacity Building",
              images: TnCBuilding,
              text: [
                "Targeted training programs for career counsellors.",
                "Practical techniques and industry advancements.",
                "Enhance your counselling approach."
              ]
            },
            {
              title: "Conferences & Networking Events",
              images: CnNEvents,
              text: [
                "Participate in dynamic conferences.",
                "Share experiences and ideas with peers.",
                "Build meaningful connections."
              ]
            },
            {
              title: "Webinars & Workshops",
              images: Webinar,
              text: [
                "Insightful webinars and workshops.",
                "Skill development and industry updates.",
                "Learn from experienced speakers."
              ]
            },
            {
              title: "Awards & Recognition",
              images: Reward,
              text: [
                "Professional certifications and awards.",
                "Acknowledgement for your dedication."
              ]
            },
            {
              title: "Research & Knowledge Development",
              images: RnKDev,
              text: [
                "Access curated resources and reports.",
                "Stay informed with industry trends.",
                "Use actionable tools and templates."
              ]
            },
            {
              title: "Public Awareness & Outreach",
              images: Public,
              text: [
                "Participate in impactful campaigns.",
                "Promote career counselling in schools and colleges."
              ]
            }
          ].map((section, idx) => (
            <div
              key={idx}
              style={{
                ...sectionStyle,
                flexDirection: isMobile ? 'column' : (idx % 2 === 0 ? 'row' : 'row-reverse'),
                backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f5f5f5'
              }}
            >
              {/* Image */}
              <div style={carouselStyle}>
                <Carousel
                  interval={3000}
                  controls
                  indicators
                  slide={false}
                >
                  {createCarouselItems(section.images)}
                </Carousel>
              </div>
              {/* Text */}
              <div style={contentStyle}>
                <h2
                  className="mb-4 font-bold text-start"
                  style={{
                    fontSize: isMobile ? '24px' : '32px', // Adjust font size for mobile and desktop
                    paddingLeft: '20px',
                  }}
                >
                  {section.title}
                </h2>
                <ul
                  style={{
                    listStyleType: 'disc',
                    paddingLeft: isMobile ? '20px' : '40px',
                    fontSize: isMobile ? '16px' : '28px', // Adjust font size for mobile and desktop
                  }}
                >
                  {section.text.map((item, i) => (
                    <li key={i} style={{ marginBottom: '10px' }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        {/* CTA Section */}
        <div style={{ textAlign: 'center', padding: '80px 20px', background: "linear-gradient(180deg, #0078BF 0%, #244183 100%) " }}>
          <motion.h3
            className="text-white"
            style={{ fontSize: '2.5rem', marginBottom: '20px' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Ready to Make a Difference?
          </motion.h3>
          <p style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto', marginBottom: '30px' }} className="text-white">
            Join the APCCI community and help shape the future of career counselling in India.
          </p>
          <motion.button
            whileHover={{ scale: 1.1 }}
            style={{
              padding: '12px 30px',
              backgroundColor: '#fff',
              color: '#0d73b9',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
            onClick={handleContact}
          >
            Get Started Now
          </motion.button>
        </div>
      </motion.div>

      <Footer />
    </>
  );
};

export default Empowers;
